// import { isNil } from 'lodash';
import { DoneIcon, YahooImage } from 'tuui';
import { SUPPLY_TARGETING_TYPES } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/const';
import { useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './SupplyTargetingIcons.module.scss';

export const SupplyTargetingIcons = ({ supplyTargeting }) => {
    const { [supplyTargeting?.iconsKey]: iconsNames } = useCommonConfig([supplyTargeting?.iconsKey]);
    const { [supplyTargeting?.moreIconsKey]: moreIcons } = useCommonConfig([supplyTargeting?.moreIconsKey]);
    const highImpactPlacements =
        supplyTargeting.id === SUPPLY_TARGETING_TYPES.YAHOO ||
        supplyTargeting.id === SUPPLY_TARGETING_TYPES.TABOOLA_SELECT;

    const icons = iconsNames?.split(',') || [];

    return (
        <div className={styles['icons-container']}>
            <YahooImage aria-label="YahooLogo" />
            {iconsNames && (
                <>
                    <div className={styles['separator']} />
                    {icons.map(icon => (
                        <div key={icon}>
                            <img
                                src={`https://www.google.com/s2/favicons?sz=32&domain_url=https://www.${icon}.com`}
                                alt="Logo"
                                className={styles['icon']}
                            />
                        </div>
                    ))}
                </>
            )}
            {moreIcons && (
                <span className={styles['more-icons']}>
                    <FormattedMessage
                        id="campaign.editor.targeting.supply.slider.more"
                        defaultMessage="+{moreIcons} more"
                        values={{
                            moreIcons,
                        }}
                    />
                </span>
            )}
            {highImpactPlacements && (
                <div className={styles['high-impact-placements']}>
                    <DoneIcon className={styles['check-icon']} fontSize="small" />
                    <FormattedMessage
                        id="campaign.editor.targeting.supply.slider.highImpactPlacements"
                        defaultMessage="High Impact Placements"
                    />
                </div>
            )}
        </div>
    );
};
